import React, { useState, useCallback } from 'react';
import SignupCollectionAction from '../SignupCollectionAction';
import Remarks from '../Remarks';

const Step6Collection = () => {
    const [isSending, setIsSending] = useState(false);
    const [canContinue, setCanContinue] = useState(false);

    const getSending = useCallback((value) => {
        setIsSending(value);
    }, []);

    const hasError = useCallback((error) => {
        setCanContinue(Boolean(!error));
    }, []);

    return (
        <>
            <div className="step-container">
                <div className="step-circle">
                    <span>6</span>
                </div>
                <Remarks getSending={getSending} hasError={hasError} />
            </div>
            <SignupCollectionAction step={6} optional={true} isValid={canContinue} isSending={isSending} />
        </>
    );
};

export default Step6Collection;
